import PropTypes from "prop-types";
import Container from "components/residency/Container";
import Title from "components/residency/Title";
import Text from "components/residency/Text";
import LinkSmooth from "components/shared/residencies/LinkSmooth";
import styles from "components/residency/Introduction.module.scss";

export default function Introduction({ description, overview }) {
  return (
    <Container className={styles.component}>
      <div className={styles.description}>
        <Title size="md" className={styles.text}>
          {description}
        </Title>
      </div>
      <div className={styles.overview}>
        <div className={styles.list}>
          {overview.map((item) => (
            <div key={item.id} className={styles.listItem}>
              <Text>
                <LinkSmooth to={item.link} className={styles.listLink}>
                  {item.title}
                </LinkSmooth>
              </Text>
              <div className={styles.listDescription}>{item.description}</div>
            </div>
          ))}
        </div>
        {/*
        <div className={styles.cta}>
          <LinkSmooth to="summary" className={styles.button}>
            Full details
          </LinkSmooth>
        </div>
        */}
      </div>
    </Container>
  );
}

Introduction.propTypes = {
  description: PropTypes.node.isRequired,
  overview: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      link: PropTypes.string,
      description: PropTypes.string,
    })
  ).isRequired,
};
